export default __webpack_public_path__ + "static/media/mouth-diagram.4ae369f5.svg";